import React, { FC } from 'react'
import styles from 'styles/components/calendar.module.scss'
import { MonthlyCalendarHeaderRow, RevenueCalendarRow } from 'components/Calendar/index'
import { getCalendarArray } from 'lib/calendar'

type Props = {
  accountingType: 'order' | 'deliver'
  selectedStartDate: Date
  selectedEndDate: Date
  startMonth: Date
  endMonth: Date
  selectDate: (date: Date) => void
}

const RevenueCalendar: FC<Props> = (props) => {
  const { accountingType, selectedStartDate, selectedEndDate, startMonth, endMonth, selectDate } = props
  const calendar = getCalendarArray(startMonth, endMonth)

  return (
    <table className={styles.table}>
      <thead>
        <MonthlyCalendarHeaderRow />
      </thead>
      <tbody>
        {calendar.map((row, rowNum) => (
          <RevenueCalendarRow
            key={rowNum}
            accountingType={accountingType}
            selectedStartDate={selectedStartDate}
            selectedEndDate={selectedEndDate}
            startMonth={startMonth}
            endMonth={endMonth}
            selectDate={selectDate}
            row={row}
          />
        ))}
      </tbody>
    </table>
  )
}

export default RevenueCalendar
